<template>
    <div id="result-container">
        <div id="result-text" class="text-center mb-1">{{ getResultText }}</div>
        <div class="result-range cursor-pointer">
            <div class="range">
                <div
                    class="side"
                    :class="{ 'bg-danger': isResultInLeftSide }"
                ></div>
                <div
                    class="center"
                    :class="{ 'bg-success': isResultInNormalRange }"
                ></div>
                <div
                    class="side"
                    :class="{ 'bg-danger': isResultInRightSide }"
                ></div>
            </div>

            <div
                id="result-marker"
                v-if="percentage"
                class="result cursor-pointer"
                :style="{ left: markerPosition }"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LabReferenceRange",
    props: {
        percentage: {
            type: String,
            default: ""
        }
    },
    computed: {
        isResultInNormalRange() {
            if (!this.percentage) return false;
            const pct = parseFloat(this.percentage);
            return pct >= 20 && pct <= 80; // 60% range centered
        },
        isResultInLeftSide() {
            if (!this.percentage) return false;
            const pct = parseFloat(this.percentage);
            return pct < 20;
        },
        isResultInRightSide() {
            if (!this.percentage) return false;
            const pct = parseFloat(this.percentage);
            return pct > 80;
        },
        getResultText() {
            if (!this.percentage) return "";
            if (this.isResultInLeftSide) return "LOW";
            if (this.isResultInNormalRange) return "NORMAL";
            if (this.isResultInRightSide) return "HIGH";
            return "";
        },
        markerPosition() {
            if (this.percentage === "20%" || this.percentage === "21%") {
                return "22%";
            } else if (this.percentage === "80%" || this.percentage === "79%") {
                return "78%";
            } else {
                return this.percentage;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.result-range {
    width: 150px;
    display: flex;
    position: relative;
    align-items: center;

    .range {
        display: flex;
        flex: 1;

        .side {
            height: 10px;
            width: 20%;
            background-color: #d9d9d9;
            float: left;
            border-radius: 10px;
            transition: background-color 0.3s ease;

            &.bg-danger {
                background-color: #FF5757;
            }
        }

        .center {
            height: 10px;
            flex: 1;
            background-color: #d9d9d9;
            margin-left: 4px;
            margin-right: 4px;
            border-radius: 10px;
            float: left;
            transition: background-color 0.3s ease;

            &.bg-success {
                background-color: #95EC80;
            }
        }
    }

    .result {
        height: 20px;
        border-left: 2px solid black;
        position: absolute;
        left: 30%;
    }
}

#result-text {
    font-weight: bold;
    font-size: 12px;
    color: #333;
    width: 150px;
}
</style>
